import { createBrowserHistory } from 'history';

// @ts-ignore
const basename = process.env.NX_PREVIEW_APP_NAME
  ? // @ts-ignore
    `/${process.env.NX_PREVIEW_APP_NAME}`
  : '/';

export default createBrowserHistory({ basename });
